export const contactsData = {
    email: 'Sodharmendra74@gmail.com',
    phone: '+917489455687',
    address: '112/1-D Asareta Pawar-(MP,465697)',

    sheetAPI: ''
}